import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-dingdan",
  "use": "icon-dingdan-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-dingdan\">\n  <path d=\"M7 4.5h10a2 2 0 0 1 2 2v15l-3-1.8-3 1.8-3-1.8-3 1.8v-15a2 2 0 0 1 2-2Z\" stroke=\"currentColor\" stroke-width=\"1.8\" stroke-linejoin=\"round\" />\n  <path d=\"M10 9h5M10 13h5M10 17h3\" stroke=\"currentColor\" stroke-width=\"1.8\" stroke-linecap=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol